/** Shared typography and button tokens for Obscura. */

/** Colori del design system (erano una costante privata della landing). */
export const C = {
  white: "#ffffff", smartWhite: "#F8FDFF", bg: "#ffffff",
  dataNight: "#182E4F", dataNight90: "#2F4361", dataNight80: "#465872", dataNight70: "#5D6D84",
  deepText: "#020818", smartBlue: "#009CDD", smartBlue70: "#4DBAE7", smartBlue50: "#80CDEE",
  smartBlue30: "#B7DAE9", smartBlue20: "#EAF8FF", smartBlue10: "#EFFAFF",
  sectionAlt: "#F7FBFD",
  blueAccent: "#59C9F4", gradientDark: "linear-gradient(180deg, #214F73 0%, #182E4F 70%)",
  border: "#def0f9", textTitle: "#182E4F", textNum: "#5D6D84", textBody: "#2F4361",
  btnBg: "#0A3458",
  shadow: "0 2px 12px rgba(24,46,79,0.06)", shadowMd: "0 4px 20px rgba(24,46,79,0.08)",
  shadowLg: "0 8px 36px rgba(24,46,79,0.10)",
  radiusCard: "15px", radiusSection: "20px", radiusBtn: "7px",
};

export const F = {
  display: "'Kumbh Sans', sans-serif",
  body: "'Roboto', sans-serif",
  /** @deprecated use F.display */
  h: "'Kumbh Sans', sans-serif",
  /** @deprecated use F.body */
  b: "'Roboto', sans-serif",
};

export const type = {
  h1: {
    fontSize: "clamp(36px, 5.8vw, 72px)",
    fontWeight: 500,
    fontFamily: F.display,
    lineHeight: 1.05,
    letterSpacing: "-0.035em",
  },
  h2: {
    fontSize: "clamp(34px, 4vw, 48px)",
    fontWeight: 500,
    fontFamily: F.display,
    lineHeight: 1.15,
  },
  h3: {
    fontSize: 24,
    fontWeight: 600,
    fontFamily: F.display,
    lineHeight: 1.25,
  },
  body: {
    fontSize: 16,
    fontWeight: 400,
    fontFamily: F.body,
    lineHeight: 1.6,
  },
  bodySm: {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: F.body,
    lineHeight: 1.5,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    fontFamily: F.body,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  btn: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: F.body,
    letterSpacing: "0.04em",
  },
};

export const btnSizes = {
  sm: { height: 38, padding: "0 18px", fontSize: 12 },
  md: { height: 44, padding: "0 24px", fontSize: 12 },
  lg: { height: 60, padding: "0 30px", fontSize: 14 },
};

export const btnBase = {
  borderRadius: 8,
  ...type.btn,
};
